module.exports = __webpack_public_path__ + "img/expand-wide.b7c0f12e.svg";